<template>
  <div class="success-content">
    <!-- 微信认证组件 -->
    <wxAuth :share="share"></wxAuth>
    <!-- title -->
    <headers :params="hraderP"></headers>
    <van-row>
      <van-col :span="24">
        <img src="//project-homedo.oss-cn-shanghai.aliyuncs.com/4fec7699-b7a1-4fd1-ad42-9f4b1ab4a129_success.png" alt="">
      </van-col>
      <van-col :span="24" class="title">提交成功！</van-col>
      <van-col :span="24" class="describe">我们即将审核您的需求,请保持手机畅通,可联系<br>在线客服或拨打021-20531391</van-col>
      <button @click="handleConfirm" class="btn">确定</button>
    </van-row>
  </div>
</template>

<script>
import headers from '@/components/headers'
import wxAuth from '@/components/wxAuth'
import { Row, Col } from 'vant'
export default {
  name: 'demand-success',
  components: { Row, Col, wxAuth, headers },
  data () {
    return {
      share: {
        title: '解决方案馆',
        desc: '智能化产品方案,产品方案,系统方案,弱电设备方案,厂商方案,产品供应商设计方案,弱电设计方案,热门方案,规划设计方案,顶层设计方案,系统解决方案,集成商方案,招标方案,投标方案,深化设计方案,施工方案',
        imgUrl: 'https://image01.homedo.com/Files/Images/cms/www/20171225/4970465306687879653_pic1.jpg',
        url: window.location.href.split('#')[0]
      },
      hraderP: {
        title: '河姆渡方案馆',
        lefticon: true
      },
      fromParam: null  // 添加fromParam存储参数
    }
  },
  mounted () {
    const urlParams = new URLSearchParams(window.location.search);
    this.fromParam = urlParams.get('from');
  },
  methods: {
    handleConfirm() {
      if (this.fromParam === 'solution') {
        window.location.href = 'https://appsolution.fat.homedo.com/#/pages/send/index';
      } else {
        this.$router.push('/');
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.success-content{
  height: 100%;
  background-color: white;
  text-align: center;
  padding-left: 3%;
  padding-right: 3%;
  img{
    margin-top: 64px;
    width: 150px;
    height: auto;
  }
  .title{
    margin-top: 15px;
    font-size: 15px;
    color: rgba(0,0,0,0.85);
   }
  .describe{
    font-size: 13px;
    color: rgba(0,0,0,0.45);
    margin-top: 15px;
  }
  .btn{
    margin-top: 65px;
    width: 343px;
    height: 44px;
    line-height: 44px;
    font-size: 18px;
    color: white;
    background-color: #2f7bff;
    border: none;
    border-radius: 5px;
  }
}

</style>



// WEBPACK FOOTER //
// src/view/demand/success.vue